<!DOCTYPE html>
<html lang="vi">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Cơ chế giải quyết tranh chấp – 11N02</title>
  <link rel="stylesheet" href="dispute-resolution.component.scss" />
</head>
<body>

<div class="policy">
  <div class="policy__content">

    <h1 class="policy__title">Cơ chế giải quyết tranh chấp</h1>
    <p class="policy__subtitle">Áp dụng cho nền tảng Sàn giao dịch thương mại điện tử 11N02</p>
    <hr class="policy__divider" />

    <p>11N02 có trách nhiệm tiếp nhận khiếu nại và hỗ trợ người tiêu dùng trong quá trình sử dụng dịch vụ trên Sàn. Khi phát sinh tranh chấp giữa các bên tham gia giao dịch, bao gồm Người mua, Người bán và đơn vị vận chuyển, 11N02 sẽ tiếp nhận thông tin, phối hợp xác minh và hỗ trợ các bên xử lý theo quy trình dưới đây.</p>

    <p>Đầu mối tiếp nhận và giải quyết tranh chấp, khiếu nại là Bộ phận Chăm sóc khách hàng của 11N02 thông qua email <a href="mailto:11N02@gmail.com">11N02&#64;com</a> và số điện thoại <a href="tel:0901110102">0901110102</a>.</p>

    <p>Quy trình giải quyết tranh chấp được thực hiện theo các bước sau:</p>

    <p><strong>Bước 1: Tiếp nhận khiếu nại:</strong> Người dùng có thể gửi khiếu nại hoặc phản ánh liên quan đến giao dịch trên Sàn 11N02 thông qua các kênh sau: Email: <a href="mailto:11N02@gmail.com">11N02&#64;com</a>, Điện thoại: <a href="tel:0901110102">0901110102</a>. Bộ phận Chăm sóc khách hàng của 11N02 sẽ tiếp nhận và ghi nhận nội dung khiếu nại của người dùng.</p>

    <p><strong>Bước 2: Xác minh thông tin:</strong> 11N02 sẽ yêu cầu các bên liên quan cung cấp thông tin, tài liệu hoặc bằng chứng liên quan đến giao dịch như mã đơn hàng, thông tin sản phẩm, hình ảnh sản phẩm, thông tin thanh toán, thông tin giao nhận, nội dung trao đổi hoặc các dữ liệu liên quan khác để phục vụ việc xác minh.</p>

    <p><strong>Bước 3: Phối hợp xử lý tranh chấp:</strong> Tùy theo tính chất của khiếu nại, 11N02 sẽ phối hợp với các bên liên quan để xử lý:</p>
    <ul>
      <li>Đối với các vấn đề liên quan đến hoạt động của website hoặc hệ thống, 11N02 sẽ trực tiếp kiểm tra và xử lý.</li>
      <li>Đối với các vấn đề liên quan đến sản phẩm như chất lượng, số lượng, mẫu mã, kích thước, màu sắc, nội dung thiết kế cá nhân hóa, đổi trả hoặc hoàn tiền, 11N02 sẽ phối hợp với Người bán để xác minh và đưa ra hướng xử lý phù hợp theo chính sách đã công bố trên Sàn.</li>
      <li>Đối với các vấn đề liên quan đến quá trình giao nhận như chậm giao, thất lạc, giao sai hàng hoặc hàng hóa bị hư hỏng trong quá trình vận chuyển, 11N02 sẽ phối hợp với Người bán, đơn vị vận chuyển và các bên liên quan để xác minh và hỗ trợ xử lý.</li>
    </ul>

    <p><strong>Bước 4: Thông báo kết quả xử lý:</strong> Sau khi xác minh và xử lý, 11N02 sẽ thông báo kết quả giải quyết khiếu nại cho các bên liên quan thông qua email, điện thoại hoặc các phương thức liên hệ phù hợp.</p>

    <p>Thời gian xử lý khiếu nại thông thường không quá 03 (ba) đến 05 (năm) ngày làm việc kể từ khi 11N02 tiếp nhận đầy đủ thông tin cần thiết.</p>

    <p>Trong trường hợp các bên không đạt được thỏa thuận hoặc tranh chấp vượt quá phạm vi xử lý của 11N02, các bên có quyền đưa vụ việc đến cơ quan có thẩm quyền để giải quyết theo quy định của pháp luật.</p>

    <p>Trong quá trình giải quyết tranh chấp, 11N02 có trách nhiệm cung cấp các thông tin liên quan đến giao dịch khi được cơ quan có thẩm quyền yêu cầu theo quy định của pháp luật Việt Nam.</p>

    <p><strong>Bước 5: Chế tài xử lý vi phạm:</strong> 11N02 tôn trọng và nghiêm túc thực hiện các quy định của pháp luật về bảo vệ quyền lợi người tiêu dùng. Trong trường hợp xác minh được lỗi phát sinh từ phía Người bán, đơn vị vận chuyển hoặc thành viên tham gia hệ thống, Ban quản lý Sàn có thể áp dụng các biện pháp xử lý phù hợp nhằm bảo vệ quyền lợi của Người mua.</p>

    <p>Các biện pháp xử lý có thể bao gồm:</p>
    <ul>
      <li>Cảnh cáo hoặc nhắc nhở thành viên vi phạm;</li>
      <li>Yêu cầu thành viên thực hiện đúng các cam kết đã thỏa thuận trong giao dịch;</li>
      <li>Yêu cầu Người bán phối hợp đổi trả, hoàn tiền hoặc khắc phục lỗi sản phẩm theo chính sách đã công bố trên Sàn;</li>
      <li>Yêu cầu bên có lỗi bồi hoàn các thiệt hại vật chất phát sinh cho Người mua nếu xác định có lỗi từ phía thành viên liên quan;</li>
      <li>Tạm ẩn sản phẩm, tạm ngừng quyền bán hàng hoặc hạn chế một số chức năng đối với tài khoản vi phạm;</li>
      <li>Tạm khóa hoặc khóa tài khoản truy cập đối với các thành viên không thực hiện nghĩa vụ khắc phục hoặc có hành vi vi phạm nghiêm trọng.</li>
    </ul>

    <hr />
    <p class="policy__footer">© 11N02. Mọi quyền được bảo lưu.</p>

  </div>
</div>

</body>
</html>